







import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class KintaiCardLabelValueItem extends Vue {
  @Prop({ default: 'plain' })
  private type!: 'plain' | 'info' | 'danger'
  @Prop({ default: '' })
  private label!: string
  @Prop({ default: '' })
  private value!: string
}
